import React from 'react';
import { CheckIcon, ShieldCheckIcon, RefreshCwIcon, CreditCardIcon } from 'lucide-react';
export const TrustBadges = () => {
  return <section className="py-10 px-4 sm:px-6 lg:px-8 bg-gray-50" data-id="element-390">
      <div className="max-w-7xl mx-auto" data-id="element-391">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-392">
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-393">
            <div className="bg-teal-100 p-2 rounded-full mb-3" data-id="element-394">
              <CheckIcon className="h-5 w-5 text-teal-600" data-id="element-395" />
            </div>
            <p className="text-sm font-medium text-gray-800" data-id="element-396">
              Revisión profesional
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-397">
            <div className="bg-teal-100 p-2 rounded-full mb-3" data-id="element-398">
              <RefreshCwIcon className="h-5 w-5 text-teal-600" data-id="element-399" />
            </div>
            <p className="text-sm font-medium text-gray-800" data-id="element-400">
              Actualizaciones gratis
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-401">
            <div className="bg-teal-100 p-2 rounded-full mb-3" data-id="element-402">
              <ShieldCheckIcon className="h-5 w-5 text-teal-600" data-id="element-403" />
            </div>
            <p className="text-sm font-medium text-gray-800" data-id="element-404">Garantía 7 días</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm flex flex-col items-center text-center" data-id="element-405">
            <div className="bg-teal-100 p-2 rounded-full mb-3" data-id="element-406">
              <CreditCardIcon className="h-5 w-5 text-teal-600" data-id="element-407" />
            </div>
            <p className="text-sm font-medium text-gray-800" data-id="element-408">
              Pago seguro y cuotas
            </p>
          </div>
        </div>
        <div className="mt-8 text-center" data-id="element-409">
          <p className="text-sm text-gray-600" data-id="element-410">
            +2.800 argentinxs ya cocinan más rico y rápido con este recetario
          </p>
        </div>
      </div>
    </section>;
};